/* eslint-disable no-nested-ternary */
import React, { Suspense, useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import type { Location } from "history";
import { IRoute } from "./RouteInterface";
import { AuthContext } from "../auth/AuthProvider";
import { Loader } from "../designSystem";

// Preserves the deep-link the user originally requested so sign-in can send them back
// to it once authenticated, instead of always landing on the default post-login page.
const buildSigninRedirectSearch = (location: Location): string => {
  const target = `${location.pathname}${location.search}${location.hash}`;

  if (!target || target === "/" || target.startsWith("/signin")) {
    return "";
  }

  return `?returnTo=${encodeURIComponent(target)}`;
};

export const RouteWithSubRoutes: React.FC<IRoute> = (route) => {
  const { currentUser, loader } = useContext(AuthContext);
  return (
    <Suspense fallback="">
      <Route
        // eslint-disable-next-line react/destructuring-assignment
        path={route.path}
        exact={route.exact}
        render={(props) =>
          route.redirect ? (
            <Redirect to={route.redirect} />
          ) : route.private ? (
            loader ? (
              <Loader variant="page" />
            ) : currentUser && !loader ? (
              route.container ? (
                <route.container {...route.containerProps}>
                  {route.component && <route.component {...props} routes={route.routes} />}
                </route.container>
              ) : (
                route.component && <route.component {...props} routes={route.routes} />
              )
            ) : (
              <Redirect
                to={{
                  pathname: "/signin",
                  search: buildSigninRedirectSearch(props.location),
                }}
              />
            )
          ) : route.container ? (
            <route.container {...route.containerProps}>
              {route.component && <route.component {...props} routes={route.routes} />}
            </route.container>
          ) : (
            route.component && <route.component {...props} routes={route.routes} />
          )
        }
      />
    </Suspense>
  );
};
